import { Module } from 'vuex';
import RootState from '../../state';
import { listItemUsingPOST } from '@services/goods/item-shelf-controller';
import { IShelfItemVO, IShelfPageParam, IItemAndSkuDetailVO } from '../../../../services/goods/models';
import { mergeWith, isArray } from 'lodash';

interface IGoodsState {
    tableData: IShelfItemVO[];
    pageTotal: number;
    // authCode: number;
    goodData: IItemAndSkuDetailVO;
    submitGoodData: { [key: string]: any };
    formGoodData: { [key: string]: any };
    needShow: boolean;
    directNeedShow: boolean;
    formData: object;
    beforeItemTypeValue?: number[];
}

const initialState = {
    tableData: [] as IShelfItemVO[],
    pageTotal: 0,
    goodData: {
        itemExtAttrInfo: {
            showItemInfo: '0',
        },
    } as IItemAndSkuDetailVO,
    submitGoodData: {
        itemCustomerServiceInfo: {},
        itemShowRule: {
            itemValidRule: {},
            purchaseNotesRule: {},
        },
        itemExtAttrInfo: {},
        poiIdList: [],
        groupPoiRelations: {},
        shopOpenApiFlag: true,
        agricultureValue: 2,
        // 是否是门店组黑名单，黑名单情况下不展示门店组,默认值不是
        isBlackList: false,
    },
    formGoodData: {},
    formData: {},
    needShow: false,
    directNeedShow: false,
    beforeItemTypeValue: [0, 0],
    // 服务商带来的编辑权限状态变更 0:无权限  1:有权限  3:只读
    // authCode: 1
    durationStartTime: 0,
};

const GoodsStore: Module<IGoodsState, RootState> = {
    namespaced: true,
    state: initialState,
    mutations: {
        setTableData(
            state: IGoodsState,
            data: { items: IShelfItemVO[]; total: number; needShow: boolean; directNeedShow: boolean; authCode: number }
        ) {
            const { items, total, needShow, directNeedShow } = data;
            state.tableData = items;
            state.pageTotal = total;
            state.needShow = needShow;
            state.directNeedShow = directNeedShow;
            // state.authCode = authCode;
        },
        setbeforeItemTypeValue(state: IGoodsState, data) {
            state.beforeItemTypeValue = data;
        },
        setGoodData(state: IGoodsState, data) {
            state.goodData = {
                ...state.goodData,
                ...data,
            };
        },
        clearGoodData(state: IGoodsState) {
            const init: any = {};
            state.goodData = init;
        },
        setSubmitGoodData(state: IGoodsState, data) {
            state.submitGoodData = {
                ...state.submitGoodData,
                ...data,
            };
        },
        setFormGoodData(state: IGoodsState, data) {
            state.formGoodData = mergeWith(state.formGoodData, data, (objValue, srcValue) => {
                if (isArray(objValue)) {
                    return srcValue;
                }
            });
        },
        setFormData(state: IGoodsState, payload) {
            state.formData[payload.key] = payload.data;
        },
        reset(state: IGoodsState) {
            state.goodData = {} as IItemAndSkuDetailVO;
            state.submitGoodData = {
                itemCustomerServiceInfo: {},
                itemShowRule: {
                    itemValidRule: {},
                    purchaseNotesRule: {},
                },
                shopOpenApiFlag: true,
            };
            state.formGoodData = {};
            state.formData = {};
            state.beforeItemTypeValue = [0, 0];
        },

        // section3/4的提交方法
        setSubmitItemValidRule(state: IGoodsState, data) {
            state.submitGoodData.itemShowRule.itemValidRule = {
                ...(state.submitGoodData.itemShowRule.itemValidRule || {}),
                ...data,
            };
        },
        // section3的提交方法
        setSubmitPurchaseNotesRule(state: IGoodsState, data) {
            state.submitGoodData.itemShowRule.purchaseNotesRule = {
                ...(state.submitGoodData.itemShowRule.purchaseNotesRule || {}),
                ...data,
            };
        },
        // section4的提交方法
        setSubmitItemCustomerServiceInfo(state: IGoodsState, data) {
            state.submitGoodData.itemCustomerServiceInfo = {
                ...state.submitGoodData.itemCustomerServiceInfo,
                ...data,
            };
        },
        // 设置电影路径
        setSubmitiItemExtAttrInfo(state: IGoodsState, data) {
            state.submitGoodData.itemExtAttrInfo = {
                ...state.submitGoodData.itemExtAttrInfo,
                ...data,
            };
        },
    },
    actions: {
        async getGoodsList(
            { commit, dispatch, state, rootState },
            payload: { param: IShelfPageParam; shopId: string }
        ) {
            try {
                const {
                    data: { items = [], total = 0, needShow = false, directNeedShow = false },
                    // authCode = 1
                } = (await listItemUsingPOST(payload || {})) || {};
                commit('setTableData', { items, total, needShow, directNeedShow });
                return { items, total };
            } catch (e) {
                commit('setTableData', { items: [], total: 0, needShow: false, directNeedShow: false });
                return { items: [], total: 0, needShow: false, directNeedShow: false };
            }
        },
        async clearGoodData({ commit }, payload) {
            commit('clearGoodData', {});
        },
        async setGoodData({ commit }, payload) {
            commit('setGoodData', payload);
        },
        async setSubmitGoodData({ commit }, payload) {
            commit('setSubmitGoodData', payload);
        },
        async setFormGoodData({ commit }, payload) {
            commit('setFormGoodData', payload);
        },
        async setFormData({ commit }, payload) {
            commit('setFormData', payload);
        },
        async reset({ commit }, payload) {
            commit('reset', payload);
        },
    },
    getters: {},
};

export default GoodsStore;
